import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import { colors, responsive, constants, fontWeight } from "buoy-theme"
import { triggerEdit } from "../../interview/actions"
import { Paragraph, ButtonLink } from "buoy-core"
import { FormattedMessage, injectIntl, defineMessages } from "react-intl"

const Symptoms = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: ${constants.boxShadow};
  padding: 0 16px;
  margin: 24px 0;
  width: 100%;
  ${responsive("max-width", "300px", "300px", "300px", "300px", "unset")};
`

const Symptom = styled.div`
  padding: 16px 0;
  border-bottom: solid 1px ${colors.neutralLighter};
  width: 100%;

  &:only-of-type,
  &:last-of-type {
    border-bottom: none;
  }
`

const SymptomTitle = styled(Paragraph)`
  font-weight: ${fontWeight.regular};
  &::first-letter {
    text-transform: capitalize;
  }
`

const Links = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
`

const Link = styled(ButtonLink).attrs({
  color: "neutralDark",
  fontSize: "bodySmall",
})`
  margin-right: 24px;

  &:only-of-type,
  &:last-of-type {
    margin-right: 0;
  }
`
const durationResponseMessages = defineMessages({
  minutes: {
    id: "duration.response.minutes",
    defaultMessage: "{value} {value, plural, one {minute} other {minutes}}",
  },
  hours: {
    id: "duration.response.hours",
    defaultMessage: "{value} {value, plural, one {hour} other {hours}}",
  },
  days: {
    id: "duration.response.days",
    defaultMessage: "{value} {value, plural, one {day} other {days}}",
  },
  weeks: {
    id: "duration.response.weeks",
    defaultMessage: "{value} {value, plural, one {week} other {weeks}}",
  },
  months: {
    id: "duration.response.months",
    defaultMessage: "{value} {value, plural, one {month} other {months}}",
  },
  years: {
    id: "duration.response.years",
    defaultMessage: "{value} {value, plural, one {year} other {years}}",
  },
})

const filterAnswerText = (items, item, intl) => {
  const { formatMessage } = intl
  const next = items
    .filter(i => i.type === "symptomBubble")
    .find(b => b.index > item.index)

  return items
    .slice(item.index, next && next.index)
    .filter(i => i.filter && i.response.length > 0)
    .map(i => {
      if (i.inputType === "duration") {
        const value = i.duration.amount
        
        switch (i.duration.unit) {
          case "minutes":
            return formatMessage(durationResponseMessages.minutes, { value })
          case "hours":
            return formatMessage(durationResponseMessages.hours, { value })
          case "days":
            return formatMessage(durationResponseMessages.days, { value })
          case "weeks":
            return formatMessage(durationResponseMessages.weeks, { value })
          case "months":
            return formatMessage(durationResponseMessages.months, { value })
          case "years":
            return formatMessage(durationResponseMessages.years, { value })
          default:
            return formatMessage(durationResponseMessages.days, { value })
        }
      } else return i.response[0].text
    }).reduce((prev, next) => {
      // return '' for empty
      // return only element in array for length 1
      // return all items joined with comma for length > 1
      return prev === '' ? [next] : [...prev, ', ', next]
    }, '')
}

const symptomBubbles = items =>
  items.filter(i => i.type === "symptomBubble" && i.finished)

const SymptomBubble = ({
  bubbles,
  items,
  triggerEdit,
  triggerDelete,
  completed,
  customSymptom,
  showDelete,
  intl
}) => (
  <Symptoms>
    {bubbles.map((item, i) => (
      <Symptom key={i}>
        <SymptomTitle color="primary" margin="0">
          {item.text}
        </SymptomTitle>
        <Paragraph margin="0">{filterAnswerText(items, item, intl)}</Paragraph>
        {!completed && (
          <Links>
            {!customSymptom && showDelete && (
              <Link onClick={() => triggerDelete(item.index)}>
                <FormattedMessage id="interview.editing.remove" defaultMessage="Remove"/>
              </Link>
            )}
            <Link onClick={() => triggerEdit(item.index)}>
              <FormattedMessage id="interview.editing.link" defaultMessage="Edit"/>
            </Link>
          </Links>
        )}
      </Symptom>
    ))}
  </Symptoms>
)

const mapStateToProps = state => ({
  bubbles: symptomBubbles(state.chatList.items),
  items: state.chatList.items,
  completed: state.completion.completed,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  triggerDelete: index => dispatch(triggerEdit(index, true)),
  triggerEdit: index => dispatch(triggerEdit(index)),
})

const SymptomBubbleContainer = injectIntl(connect(mapStateToProps, mapDispatchToProps)(
  SymptomBubble)
)

export { SymptomBubbleContainer as default, SymptomBubble }



// WEBPACK FOOTER //
// ./assets/search/components/SymptomBubble.js